import styled from 'styled-components/macro';

export const Cell = styled.div`
  grid-area: ${props => props.area};
  display: flex;
  align-items: center;
  justify-content: ${({ centered }) => (centered ? `center` : ``)};
  position: relative;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    button {
      width: 100%;
    }
  }
`;
